namespace Portico.Models.Enterprise {
    import psge = apigateway.enums;
    import psgm = apigateway.models;

    export interface IExternalId {
        id: number;
        type: number | string;
        value: string;
    }

    export class ExternalId implements IExternalId {
        id: number;
        type: number| string;
        value: string;

        constructor(obj?: IExternalId | any) {
            this.id = null;
            this.type = null;
            this.value = '';

            if (obj) {
                this.id = obj.id || obj.Id || null;
				this.type = obj.type || obj.externalIdType || null;
				this.value = obj.value || obj.externalId || '';
            }
        }

        mapToEnterpriseCoordinatorExternalId() : psgm.EnterpriseCoordinatorSharedExternalIdUpsearchModel {
            return {
                id: this.id,
                externalIdType:  typeof this.type === 'number' ?  this.type : psge.PartyExternalIdType[this.type],
                externalId: this.value
            } as psgm.EnterpriseCoordinatorSharedExternalIdUpsearchModel
        }
    }
}
